import {  HOME_SECTIONS_LOADER,GET_RECENTLY_VIEW_COLLECTION } from '../../constants/reducerTypes';

const initialState = {};
const recentlyViewedReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case HOME_SECTIONS_LOADER:
      return {
        ...state,
        searchLoader: true
      };
    case GET_RECENTLY_VIEW_COLLECTION:
      return {
        ...state,
        recentlyCollection: action.payload.results,
        recentlyTotalRows: action.payload.recentTotalRows,
        searchLoader: false
      };
    default:
      return state;
  }
};
export default recentlyViewedReducer;
